/*----- Core -----*/
import React 		   from 'react'
import { connect } from "react-redux"

/*----- Ant -----*/
import { Modal } from 'antd'

/*----- Selectors  -----*/
import { modalVisibleSelector }   from '../modules/app/Selectors'

/*----- Actions  -----*/
import { toggleModal }   from '../modules/app/Actions'

import styled from 'styled-components'

const ContentContainer = styled.div`

`

/*----- Export -----*/
const CustomModal = ({ children,  modalVisible, toggleModal, styles }) => (
	<Modal
		style     = { styles }
		visible   = { modalVisible }
		footer    = { null }
		onCancel  = { ()=> toggleModal() }
		centered
	>
		<ContentContainer>
			{ children }
		</ContentContainer>
	</Modal>
)

const mapStateToProps = (state) => {
	return {
    modalVisible: modalVisibleSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		toggleModal: () => toggleModal(dispatch)
	}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomModal)
